import { Injectable } from "@angular/core";
import { String } from "lodash";

export interface UseCategory {
    header: string;
    options: string[];
}

export interface HazardPhrase {
    header: string;
    options: string[];
}

@Injectable()
export class FormulaGlobalDataService {



    generalPCode = [
        "P101:If medical advice is needed have product container or label at hand.",
        "P102:Keep out of reach of children.",
        "P103:Read label before use."
    ]

    preventionPCode = [
        "P201:Obtain special instructions before use.",
        "P202:Do not handle until all safety precautions have been read and understood.",
        "P203: Obtain, read and follow all safety instructions before use.",
        "P210:Keep away from heat/sparks/open flames/hot surfaces.  — No smoking.",
        "P211:Do not spray on an open flame or other ignition source.",
        "P212: Avoid heating under confinement or reduction of the desensitizing agent.",
        "P220:Keep/Store away from clothing/…/combustible materials.",
        "P221:Take any precaution to avoid mixing with combustibles/…",
        "P222:Do not allow contact with air.",
        "P223:Keep away from any possible contact with water because of violent reaction and possible flash fire.",
        "P230:Keep wetted with …",
        "P231:Handle under inert gas.",
        "P232:Protect from moisture.",
        "P233:Keep container tightly closed.",
        "P234:Keep only in original container.",
        "P235:Keep cool.",
        "P236: Keep only in original packaging; Division...in the transport configuration.",
        "P240:Ground/bond container and receiving equipment.",
        "P241:Use explosion-proof electrical/ventilating/lighting/…/equipment.",
        "P242:Use only non-sparking tools.",
        "P243:Take precautionary measures against static discharge.",
        "P244:Keep reduction valves free from grease and oil.",
        "P250:Do not subject to grinding/shock/…/friction.",
        "P251:Pressurized container:Do not pierce or burn, even after use.",
        "P260:Do not breathe dust/fume/gas/mist/vapours/spray.",
        "P261:Avoid breathing dust/fume/gas/mist/vapours/spray.",
        "P262:Do not get in eyes on skin or on clothing.",
        "P263:Avoid contact during pregnancy/while nursing.",
        "P264:Wash hands thoroughly after handling.",
        "P265: Do not touch eyes.",
        "P270:Do not eat drink or smoke when using this product.",
        "P271:Use only outdoors or in a well-ventilated area.",
        "P272:Contaminated work clothing should not be allowed out of the workplace.",
        "P273:Avoid release to the environment.",
        "P280:Wear protective gloves/protective clothing/eye protection/face protection.",
        "P281:Use personal protective equipment as required.",
        "P282:Wear cold insulating gloves/face shield/eye protection.",
        "P283:Wear fire/flame resistant/retardant clothing.",
        "P284:Wear respiratory protection.",
        "P285:In case of inadequate ventilation wear respiratory protection.",
        "P231+P232:Handle under inert gas.  Protect from moisture.",
        "P264+P265: Wash hands and thoroughly after handling. Do not touch eyes.",
        "P235+P410:Keep cool.  Protect from sunlight."
    ]


    public responsePCode: string[] = [
        "P301:IF SWALLOWED",
        "P302: IF ON SKIN"
        , "P303: IF ON SKIN (or hair)"
        , "P304: IF INHALED"
        , "P305: IF ON EYES"
        , "P306: IF ON CLOTHING",
        "P308:IF exposed or concerned",
        "P309:IF exposed or if you feel unwell",
        "P310:Immediately call a POISON CENTER or doctor/physician",
        "P302:IF ON SKIN",
        "P303:IF ON SKIN (or hair)",
        "P304:IF INHALED",
        "P305:IF IN EYES",
        "P306:IF ON CLOTHING",
        "P307:IF exposed",
        "P311:Call a POISON CENTER or doctor/physician.",
        "P312:Call a POISON CENTER or doctor/physician if you feel unwell.",
        "P313:Get medical advice/attention.",
        "P314:Get medical advice/attention if you feel unwell.",
        "P315:Get immediate medical advice/attention."
        , "P316: Get emergency medical help immediately. "
        , "P317: Get medical help."
        , "P318: IF exposed or concerned, get medical advice."
        , "P319: Get medical help if you feel unwell.",
        "P320: Specific treatment is urgent (see … on this label).",
        "P321:Specific treatment (see … on this label).",
        "P322:Specific measures (see …on this label).",
        "P330:Rinse mouth.",
        "P331:Do NOT induce vomiting.",
        "P332:IF SKIN irritation occurs",
        "P333:If skin irritation or rash occurs",
        "P334:Immerse in cool water/wrap in wet bandages.",
        "P335:Brush off loose particles from skin.",
        "P336:Thaw frosted parts with lukewarm water. Do not rub affected area.",
        "P337:If eye irritation persists",
        "P338:Remove contact lenses if present and easy to do.  Continue rinsing.",
        "P340:Remove victim to fresh air and keep at rest in a position comfortable for breathing.",
        "P341:If breathing is difficult remove victim to fresh air and keep at rest in a position comfortable for breathing.",
        "P342:If experiencing respiratory symptoms",
        "P350:Gently wash with plenty of soap and water.",
        "P351:Rinse cautiously with water for several minutes.",
        "P352:Wash with plenty of soap and water.",
        "P353:Rinse skin with water/shower.",
        "P354: Immediately rinse with for several minutes",
        "P360:Rinse immediately contaminated clothing and skin with plenty of water before removing clothes.",
        "P361:Remove/Take off immediately all contaminated clothing.",
        "P362:Take off contaminated clothing and wash before reuse.",
        "P363:Wash contaminated clothing before reuse.",
        "P364: And wash it before reuse.",
        "P370:In case of fire:…",
        "P371:In case of major fire and large quantities:…",
        "P372:Explosion risk in case of fire.",
        "P373:DO NOT fight fire when fire reaches explosives.",
        "P374:Fight fire with normal precautions from a reasonable distance.",
        "P375: Fight fire remotely due to the risk of explosion.",
        "P376:Stop leak if safe to do so.",
        "P377:Leaking gas fire: Do not extinguish, unless leak can be stopped safely.",
        "P378:Use … for extinction.",
        "P380:Evacuate area.",
        "P381:Eliminate all ignition sources if safe to do so.",
        "P390:Absorb spillage to prevent material damage.",
        "P391:Collect spillage. Hazardous to the aquatic environment",
        "P301+P316: IF SWALLOWED: Get emergency medical help immediately.",
        "P301+P317: IF SWALLOWED: Get medical help",
        "P301+P310:IF SWALLOWED :Immediately call a POISON CENTER or doctor/physician.",
        "P301+P312:IF SWALLOWED :call a POISON CENTER or doctor/physician if you feel unwell.",
        "P301+P330+P331:IF SWALLOWED :Rinse mouth.  Do NOT induce vomiting.",
        "P302+P317:IF ON SKIN: Get medical help",
        "P302+P334:IF ON SKIN :Immerse in cool water/wrap in wet bandages.",
        "P302+P350:IF ON SKIN:Gently wash with plenty of soap and water.",
        "P302+P335+P334: IF ON SKIN: Brush off loose particles from skin and immerse in cool water or wrap in wet bandages.",
        "P302+P361+P354: IF ON SKIN: Take off immediately all contaminated clothing. Immediately rinse with water for several minutes.",

        "P302+P352:IF ON SKIN :wash with plenty of soap and water.",
        "P303+P361+P353:IF ON SKIN (or hair) :Remove/Take off Immediately all contaminated clothing.  Rinse SKIN with water/shower.",
        
        "P304+P312:IF INHALED:Call a POISON CENTER or doctor/physician if you feel unwell.",
        "P304+P317:IF INHALED: Get medical help",
        "P304+P340:IF INHALED :Remove victim to fresh air and Keep at rest in a position comfortable for breathing.",
        "P304+P341:IF INHALED :If breathing is difficult remove victim to fresh air and keep at rest in a position comfortable for breathing.",
        "P305+P354+P338: IF IN EYES: Immediately rinse with water for several minutes. Remove contact lenses, if present and easy to do. Continue rinsing.",
        "P305+P351+P338:IF IN EYES :Rinse cautiously with water for several minutes.  Remove contact lenses, if present and easy to do.  Continue rinsing.",
        "P306+P360:IF ON CLOTHING :Rinse Immediately contaminated CLOTHING and SKIN with plenty of water before removing clothes.",
        "P307+P311:IF exposed :Call a POISON CENTER or doctor/physician.",
        "P308+P316: IF exposed or concerned: Get emergency medical help immediately.",
        "P308+P313:IF exposed or concerned :Get medical advice/attention.",
        "P309+P311:IF exposed or if you feel unwell:call a POISON CENTER or doctor/physician.",

        "P332+P313:IF SKIN irritation occurs :Get medical advice/attention.",
        "P333+P313:IF SKIN irritation or rash occurs :Get medical advice/attention."
        , "P332+P317: If skin irritation or rash occurs: Get medical help"
        , "P333+P317: If skin irritation or rash occurs: Get medical help"
        , "P336+P317: Immediately thaw frosted parts with lukewarm water. Do not rub affected area. Get medical help."
        , "P337+P317: If eye irritation persists: Get medical help"
        , "P342+P316: If experiencing respiratory symptoms: Get emergency medical help immediately."
        , "P361+P364: Take off immediately all contaminated clothing and wash it before reuse. "
        , "P362+P364: Take off contaminated clothing and wash it before reuse."
        , "P370+P380+P375: in case of major fire and large quantities: Evacuate area. Fight fire remotely due to the risk of explosion."
        , "P371: In case of major fire and large quantities: Evacuate area. Fight fire remotely due to the risk of explosion."
        , "P370+P372+P380+P373: In case of fire: Explosion risk. Evacuate area. DO NOT fight fire when fire reaches explosives."
        , "P370+P380+P375+P378: In case of fire: Evacuate area. Fight fire remotely due to the risk of explosion. Use..to extinguish.",

        "P335+P334:Brush off loose particles from skin. Immerse in cool water/wrap in wet bandages.",
        "P337+P313:IF eye irritation persists :Get medical advice/attention.",
        "P342+P311:IF experiencing respiratory symptoms :call a POISON CENTER or doctor/physician.",
        "P370+P376:In case of fire: Stop leak if safe to Do so.",
        "P370+P378:In case of fire: Use … for extinction.",
        "P370+P380:In case of fire: Evacuate area.",
        "P370+P380+P375:In case of fire: Evacuate area. Fight fire remotely due to the risk of explosion.",
        "P371+P380+P375:In case of major fire and large quantities :Evacuate area. Fight fire remotely due to the risk of explosion.",
    ]


    storagePCode = [
        "P401:Store in accordance with…",
        "P402:Store in a dry place.",
        "P403:Store in a well-ventilated place.",
        "P404:Store in a closed container.",
        "P405:Store locked up.",
        "P406:Store in corrosive resistant/… container with a resistant inner liner.",
        "P407:Maintain air gap between stacks/pallets.",
        "P410:Protect from sunlight.",
        "P411:Store at temperatures not exceeding … °C/… °F.",
        "P412:Do not expose to temperatures exceeding 50 °C/ 122 °F.",
        "P413:Store bulk masses greater than … kg/…lbs at temperatures not exceeding … °C/…°F.",
        "P420:Store away from other materials.",
        "P422:Store contents under",
        "P402+P404:Store in a dry place Store in a closed container.",
        "P403+P233:Store in a well-ventilated place, Keep container tightly closed.",
        "P403+P235:Store in a well-ventilated place, Keep cool.",
        "P410+P403:Protect from sunlight Store in a well-ventilated place.",
        "P410+P412:Protect from sunlight. Do not expose to temperatures exceeding 50 °C/122 °F.",
        "P411+P235:Store at temperatures not exceeding … °C/…°F. Keep cool.",
        "P501: Dispose of contents/container to...",
        "P502: Refer to manufacturer/supplier for information on recovery/recycling",
        "P503: Refer to manufacturer/supplier… for information on disposal/recovery/recycling. "

    ]



    physicalHazardCode = ["H200:Unstable explosive",
        "H201:Explosive; mass explosion hazard",
        "H202:Explosive; severe projection hazard",
        "H203:Explosive; fire blast or projection hazard",
        "H204:Fire or projection hazard",
        "H205:May mass explode in fire",
        "H206:Fire blast or projection hazard: increased risk of explosion if desensitizing agent is reduced",
        "H207:Fire or projection hazard: increased risk of explosion if desensitizing agent is reduced",
        "H208:Fire hazard: increased risk of explosion if desensitizing agent is reduced",
        "H209 :EXPLOSIVE",
        "H210:VERY SENSITIVE",
        "H211:May be sensitive",
        "H220:Extremely flammable gas",
        "H221:Flammable gas",
        "H222:Extremely flammable aerosol",
        "H223:Flammable aerosol",
        "H224:Extremely flammable liquid and vapour ",
        "H225:Highly flammable liquid and vapour",
        "H226:Flammable liquid and vapour",
        "H227:Combustible liquid",
        "H228:Flammable solid ",
        "H229:Pressurized container: may burst if heated",
        "H230:May react explosively even in the absence of air  ",
        "H231:May react explosively even in the absence of air at elevated pressure and/or temperature",
        "H232:May ignite spontaneously if exposed to air",
        "H240:Heating may cause an explosion",
        "H241:Heating may cause a fire or explosion ",
        "H242:Heating may cause a fire",
        "H250:Catches fire spontaneously if exposed to air",
        "H251:Self-heating; may catch fire",
        "H252:Self-heating in large quantities; may catch fire ",
        "H260:In contact with water releases flammable gases which may ignite spontaneously",
        "H261:In contact with water releases flammable gas",
        "H270:May cause or intensify fire; oxidizer ",
        "H271:May cause fire or explosion; strong oxidizer",
        "H272:May intensify fire; oxidizer",
        "H280:Contains gas under pressure; may explode if heated",
        "H281:Contains refrigerated gas; may cause cryogenic burns or injury",
        "H282:Extremely flammable chemical under pressure: May explode if heated.",
        "H283:Flammable chemical under pressure: May explode if heated",
        "H284:Chemical under pressure: May explode if heated",
        "H290:May be corrosive to metals "
    ]

    healthHazardCode = [
        "H300:Fatal if swallowed",
        "H301:Toxic if swallowed",
        "H302:Harmful if swallowed",
        "H303:May be harmful if swallowed",
        "H304:May be fatal if swallowed and enters airways",
        "H305:May be harmful if swallowed and enters airways",
        "H310:Fatal in contact with skin",
        "H311:Toxic in contact with skin",
        "H312:Harmful in contact with skin",
        "H313 :Maybe harmful in contact with skin",
        "H314:Causes severe skin burns and eye damage",
        "H315:Causes skin irritation",
        "H316:Causes mild skin irritation",
        "H317:May cause an allergic skin reaction",
        "H318:Causes serious eye damage",
        "H319:Causes serious eye irritation",
        "H320:Causes eye irritation",
        "H330:Fatal if inhaled",
        "H331:Toxic if inhaled",
        "H332:Harmful if inhaled",
        "H333:Maybe harmful if inhaled",
        "H334:May cause allergy or asthma symptoms or breathing difficulties if inhaled",
        "H335:May cause respiratory irritation",
        "H336:May cause drowsiness or dizziness",
        "H340:May cause genetic defects",
        "H341:Suspected of causing genetic defects",
        "H350:May cause cancer",
        "H350i:May cause cancer by inhalation",
        "H351:Suspected of causing cancer     ",
        "H360:May damage fertility or the unborn child",
        "H360F:May damage fertility ",
        "H360D:May damage the unborn child ",
        "H360FD:May damage fertility. May damage the unborn child ",
        "H360Fd:May damage fertility. Suspected of damaging unborn child ",
        "H360Df:May damage the unborn child. Suspected of damaging fertility   ",
        "H361:Suspected of damaging fertility or the unborn child ",
        "H361d:Suspected of damaging the unborn child  ",
        "H361f:Suspected of damaging fertility",
        "H361fd:Suspected of damaging fertility. Suspected of damaging the unborn child.  ",
        "H362:May cause harm to breast-fed children   ",
        "H370:Causes damage to organs  ",
        "H371:May cause damage to organs      ",
        "H372:May cause damage to organs through prolonged or repeated exposure",
        "H373:Causes damage to organs through prolonged or repeated exposure",
        "H300+H310:Fatal if swallowed or in contact with skin   ",
        "H300+H330:Fatal if swallowed or if inhaled ",
        "H310+H330:Fatal in contact with skin or if inhaled ",
        "H300+H310+H330:Fatal if swallowed in contact with skin or if inhaled   ",
        "H301+H311:Toxic if swallowed or in contact with skin   ",
        "H301+H331:Toxic if swallowed or if inhaled ",
        "H311+H331:Toxic in contact with skin or if inhaled ",
        "H301+H311+H331:Toxic if swallowed in contact with skin or if inhaled   ",
        "H302+H312:Harmful if swallowed or in contact with skin ",
        "H302+H332:Harmful if swallowed or if inhaled",
        "H312+H332:Harmful in contact with skin or if inhaled   ",
        "H302+H312+H332:Harmful if swallowed in contact with skin or if inhaled ",
        "H303+H313:May be harmful if swallowed or in contact with skin",
        "H303+H333:May be harmful if swallowed or if inhaled",
        "H313+H333:May be harmful in contact with skin or if inhaled  ",
        "H303+H313+H333:May be harmful if swallowed in contact with skin or if inhaled",
        "H315+H319:Causes skin irritation and serious eye irritation",
        "H315+H320:Causes skin and eye irritation "
    ]

    environmentHazardCode = [

        "H400:Very toxic to aquatic life.",
        "H401:Toxic to aquatic life",
        "H402:Harmful to aquatic life",
        "H410:Very toxic to aquatic life with long lasting effects",
        "H411:Toxic to aquatic life with long lasting effects",
        "H412:Harmful to aquatic life with long lasting effects",
        "H413:May cause long lasting harmful effects to aquatic life",
        "H420:Harms public health and the environment by destroying ozone in the upper atmosphere"

    ]
    hazardPhrases: HazardPhrase[] = [
        {
            header: "H-200 PHYSICAL HAZARDS",
            options: ["H200 Unstable explosive", "H201 Explosive; mass explosion hazard", "H202 Explosive; severe projection hazard", "H203 Explosive; fire", "H204 Fire or projection hazard", "H205 May mass explode in fire", "H206 Fire", "H207 Fire or projection hazard: increased risk of explosion if desensitizing agent is reduced", "H208 Fire hazard: increased risk of explosion if desensitizing agent is reduced", "H220 Extremely flammable gas", "H221 Flammable gas", "H222 Extremely flammable aerosol", "H223 Flammable aerosol", "H224 Extremely flammable liquid and vapour", "H225 Highly flammable liquid and vapour", "H226 Flammable liquid and vapour", "H227 Combustible liquid", "H228 Flammable solid", "H229 Pressurized container: may burst if heated", "H230 May react explosively even in the absence of air", "H231 May react explosively even in the absence of air at elevated pressure and/or temperature", "H232 May ignite spontaneously if exposed to air", "H240 Heating may cause an explosion", "H241 Heating may cause a fire or explosion", "H242 Heating may cause a fire", "H250 Catches fire spontaneously if exposed to air", "H251 Self-heating; may catch fire", "H252 Self-heating in large quantities; may catch fire", "H260 In contact with water releases flammable gases which may ignite spontaneously", "H261 In contact with water releases flammable gas", "H270 May cause or intensify fire; oxidizer", "H271 May cause fire or explosion; strong oxidizer", "H272 May intensify fire; oxidizer", "H280 Contains gas under pressure; may explode if heated", "H281 Contains refrigerated gas; may cause cryogenic burns or injury", "H290 May be corrosive to metals"]
        },
        {
            header: "H-300 HEALTH HAZARDS",
            options: ["H300 Fatal if swallowed", "H301 Toxic if swallowed", "H302 Harmful if swallowed", "H303: May be harmful if swallowed", "H304 May be fatal if swallowed and enters airways", "H305 May be fatal if swallowed and enters airways", "H310 Fatal in contact with skin", "H311 Toxic in contact with skin", "H312 Harmful in contact with skin", "H314 Causes severe skin burns and eye damage", "H315 Causes skin irritation", "H317 May cause an allergic skin reaction", "H318 Causes serious eye damage", "H319 Causes serious eye irritation", "H330 Fatal if inhaled", "H331 Toxic if inhaled", "H332 Harmful if inhaled", "H334 May cause allergy or asthma symptoms or breathing difficulties if inhaled", "H335 May cause respiratory irritation", "H336 May cause drowsiness or dizziness", "H340 May cause genetic defects", "H341 Suspected of causing genetic defects", "H350 May cause cancer", "H350i May cause cancer by inhalation", "H351 Suspected of causing cancer", "H360 May damage fertility or the unborn child", "H360F May damage fertility", "H360D May damage the unborn child", "H360FD May damage fertility. May damage the unborn child", "H360Fd May damage fertility.Suspected of damaging unborn child", "H360Df May damage the unborn child.Suspected of damaging fertility", "H361 Suspected of damaging fertility or the unborn child", "H361d Suspected of damaging the unborn child", "H361f Suspected of damaging fertility", "H361fd Suspected of damaging fertility. Suspected of damaging the unborn child.", "H362 May cause harm to breast-fed children", "H370 Causes damage to organs", "H371 May cause damage to organs", "H372 Causes damage to organs through prolonged or repeated exposure", "H373 Causes damage to organs through prolonged or repeated exposure", "H300+H310: Fatal if swallowed or in contact with skin", "H300+H330: Fatal if swallowed or if inhaled", "H310+H330: Fatal in contact with skin or if inhaled", "H300+H310+H330: Fatal if swallowed", "H301+H311: Toxic if swallowed or in contact with skin", "H301+H331: Toxic if swallowed or if inhaled", "H311+H331: Toxic in contact with skin or if inhaled", "H301+H311+H331: Toxic if swallowed", "H302+H312: Harmful if swallowed or in contact with skin", "H302+H332: Harmful if swallowed or if inhaled", "H312+H332: Harmful in contact with skin or if inhaled", "H302+H312+H332: Harmful if swallowed", "H303+H313: May be harmful if swallowed or in contact with skin", "H303+H333: May be harmful if swallowed or if inhaled", "H313+H333: May be harmful in contact with skin or if inhaled", "H303+H313+H333: May be harmful if swallowed", "H315+H320: Causes skin and eye irritation"]
        },
        {
            header: "H-400 ENVIRONMENTAL HAZARDS",
            options: ["H400 Very toxic to aquatic life.", "H410 Very toxic to aquatic life with long lasting effects", "H411 Toxic to aquatic life with long lasting effects", "H412 Harmful to aquatic life with long lasting effects", "H413 May cause long lasting harmful effects to aquatic life"]
        },
        {
            header: "ADDITIONAL HAZARD PHRASES",
            options: ["EUH001 Explosive when dry", "EUH006 Explosive with or without contact with air", "EUH014 Reacts violently with water", "EUH018 In use may form flammable / explosive vapour-air mixture", "EUH019 May form explosive peroxides", "EUH029 Contact with water liberates toxic gas", "EUH031 Contact with acids liberates toxic gas", "EUH032 Contact with acids liberates very toxic gas", "EUH044 Risk of explosion if heated under confi nement", "EUH059 Hazardous to the ozone layer", "EUH066 Repeated exposure may cause skin dryness or cracking", "EUH070 Toxic by eye contact", "EUH071 Corrosive to the respiratory tract. Contains lead. Should not be used on surfaces liable to the chewed or sucked by children. Warning! Contains lead.", "EUH202 Cyanoacrylate. Danger. Bonds skin and eyes in seconds. Keep out of the reach of children", "EUH203 Contains chromium (VI). May produce an allergic reaction", "EHU204 Contains isocyanates. May produce an allergic reaction", "EUH205 Contains epoxy constituents. May produce an allergic reaction", "EUH206 Warning! Do not use together with other products. May release gangerous gases (chlorine)", "EUH207 Warning! Contains cadmium. Dangerous fumes are formed during use. See information supplied by the manufacturer", "EUH208 Contains <name of sensitising substance>. May produce an allergic reaction.Can become highly fl ammable in use. Can become flammable inuse", "EUH210 Safety data sheet available on request", "EUH401 To avoid risks to human health and the environment"]
        }
    ];

    useCategories: UseCategory[] = [
        {
            header: "1.1 Auxiliaries and Finishing Agents for Fibres",
            options: ["1.1.1 Spinning solution additives", "1.1.2 Spinning additives", "1.1.3 Spinning bath additives", "1.1.4 Preparation agent", "1.1.5 Lubricants", "1.1.6 Coning oils", "1.1.7 Conditioning and stabilizing agents", "1.1.8 Other"]
        },
        {
            header: "1.2 Pretreatment Agents",
            options: ["1.2.1 Fibre protecting agents in pretreatment", "1.2.2 Kierboiling/Scouring auxiliaries", "1.2.3 Bleaching auxiliaries", "1.2.4 Mercerising and causticizing auxiliaries", "1.2.5 Carbonizing assistants", "1.2.6 Sizing agents and sizing additives", "1.2.7 Desizing agents", "1.2.8 Hydrophilizing agents", "1.2.9 Enzymes", "1.2.10 Sequestring agents", "1.2.11 Stabilizers"]
        },
        {
            header: "1.3 Textile Auxiliaries for Dyeing and Printing",
            options: ["1.3.1 Dyestuff solubilizing and hydrotropic agents", "1.3.2 Dispersing agents and protective colloids", "1.3.3 Dyeing wetting agents", "1.3.4 Leveling agents", "1.3.5 Carriers", "1.3.6 Crease-preventing agents", "1.3.7 Dyestuff protecting agents", "1.3.8 Padding Auxiliaries", "1.3.8.1 Anti-migration agents", "1.3.8.2 Anti-frosting auxiliaries", "1.3.8.3 Products increasing wet-pick-up", "1.3.9 Fix accelarators for continuous dyeing and printing", "1.3.10 Aftertreatment agents for fastness improvement", "1.3.11 Bonding agent (binders) for pigment dyeing and printing", "1.3.12 Printing thickeners", "1.3.13 Emulsifiers for gasoline printing (white spirit for oil-water emulsion printing)", "1.3.14 Agents to remove printing thickeners", "1.3.15 Printing and edge adhesives", "1.3.16 Oxidizing agents", "1.3.17 Reducing agents", "1.3.18 Discharging agents and discharging assistants", "1.3.19 Resistant agents", "1.3.20 Mordants", "1.3.21 Brightening and stripping agents", "1.3.22 Fibre-protective agents in dyeing", "1.3.23 pH-regulators", "1.3.24 Adhesives", "1.3.25 Pvc-Based (Plastisols) Ready To Use Printing Pastes", "1.3.26 Water-Based Ready To Use Printing Pastes", "1.3.27 Other Pigmant Based Ready To Use Printing Pastes"]
        },
        {
            header: "1.4 Finishing Assistants",
            options: ["1.4.1 Optical brighteners (fluorescent brighteners)", "1.4.2 Agents for the improvement of crease and shrink resistance", "1.4.3 Additives for non-creasing and non-shrinking finishes", "1.4.4 Catalysts for non-creasing and non-shrinking finishes", "1.4.5 Handle-imparting agents", "1.4.5.1 Weighting agents", "1.4.5.2 Filling and stifening agents", "1.4.5.3 Softening agents", "1.4.6 Anti-electrostatic agent", "1.4.7 Water, stain and oil repellents", "1.4.8 Soil release agents", "1.4.9 Felting agent", "1.4.10 Anti-felting agents", "1.4.11 Conditioning agents", "1.4.12 Lustring agents", "1.4.13 Delustering agent", "1.4.14 Non-slip", "1.4.15 Flame retardants", "1.4.16 Anti-microbiotics", "1.4.16.1 Finishing", "1.4.16.2 Storage stability", "1.4.17 Agents to protect textiles against damage caused by insects etc.", "1.4.18 Agents and additives to promote bonding of fibres and threads", "1.4.19 Coating agents as well as according additives", "1.4.20 Laminating agents as well as according additives", "1.4.21 UV Protection"]
        },
        {
            header: "1.5 Technical Auxiliaries for multipurpose use in the textile industry",
            options: ["1.5.1 Wetting agents", "1.5.2 Anti-foaming agents (foam inhibitors)", "1.5.3 Detergents", "1.5.4 Spotting agents", "1.5.5 Chelating agents", "1.5.6 Stabilizers"]
        },
        {
            header: "1.6 Other Auxiliaries",
            options: ["1.6.1 Drycleaning  detergents", "1.6.2 Prespotting agents", "1.6.6 Defoaming agents for solvent application", "1.6.7 Resin permanent", "1.6.8 Resin thermoplastic", "1.6.9 Resin thermosensible", "1.6.10 Soaping", "1.6.11 Other Auxillaries"]
        },
        {
            header: "1.7 Dyes and Pigments",
            options: ["1.7.1 Pigments", "1.7.2 Reactive dye", "1.7.3 Sulphur dye", "1.7.4 Mordant dye", "1.7.5 Direct dye", "1.7.6 Disperse dye", "1.7.7 Basic dye (cationic dye)", "1.7.8 Acid dye", "1.7.9 Metal complex dyes (for WO / PA)", "1.7.10 Vat dye"]
        },
        {
            header: "1.8. Anciliaries",
            options: ["1.8.1 Cleaning / Maintenance Products", "1.8.2 Other Anciliaries"]
        },
        {
            header: "2.1 ACIDS",
            options: ["2.1.a Acids_Hydroxy-carboxylic acids (Deliming agents)", "2.1.b Acids_Mineral acids", "2.1.c Acids_Organic acids", "2.1.d Acids_Blend of organic and inorganic acids"]
        },
        {
            header: "2.2 AUXILIARIES",
            options: ["2.2.a Antifoam / slip agents", "2.2.b Leveling agent", "2.2.c Defoamer", "2.2.d Foam stabilizer", "2.2.e Penetrator", "2.2.f Rheology Modifier", "2.2.g Water and effluent treatment chemicals"]
        },
        {
            header: "2.3 BASES",
            options: ["2.3.a Bases_Ammonia or Amino-", "2.3.b Bases_Calcium formate", "2.3.c Bases_Lime (calcium hydroxide)", "2.3.d Bases_Magnesium oxide", "2.3.e Bases_Sodium acetate trihydrate", "2.3.f Bases_Sodium bicarbonate", "2.3.g Bases_Sodium carbonate", "2.3.h Bases_Sodium formate", "2.3.i Bases_Sodium hydroxide", "2.3.j Bases_Blends"]
        },
        {
            header: "2.4 BEAMHOUSE AGENTS",
            options: ["2.4.a Bating and other enzymes (Proteins)", "2.4.b Bleaching or dehairing agent", "2.4.c Sequestering agents", "2.4.d Soaking Agents"]
        },
        {
            header: "2.5 DEGREASING AGENTS",
            options: ["2.5.a Degreasing agents_anionic e. g. Alkyl-Benzene-Sulfonates", "2.5.b Degreasing agents_ non-ionic", "2.5.c Degreasing agents_non-ionic Ethoxylated fatty alcohol (APEO free)", "2.5.d Degreasing agents_cationic or amphoteric e.g. Ethoxylated fatty amines", "2.5.e Degreasing agents_ non-ionic and anionic"]
        },
        {
            header: "2.6 DYEING AUXILIARIES",
            options: ["2.6.a Penetration"]
        },
        {
            header: "2.7 DYESTUFFS & PIGMENTS",
            options: ["2.7.a Dyestuff (aqueous based)_Acid azodyes", "2.7.b Dyestuff (aqueous based)_Basic azodyes", "2.7.c Dyestuff (aqueous based)_Direct dyes", "2.7.d Dyestuff (aqueous based)_Metal complex dyes", "2.7.e Dyestuff (aqueous based)_Reactive dyes", "2.7.f Dyestuff (aqueous based)_Sulfur dyes", "2.7.g Dyestuff (Solvent Based for finishing)_Azodyes or Azo", "2.7.h Pigments_Inorganic pigments (iron oxide)", "2.7.i Pigments_Inorganic pigments (titanium dioxide)", "2.7.l Pigments_Organic and metal- complex pigments"]
        },
        {
            header: "2.8 FATLIQUORS AND OILS",
            options: ["2.8.a Fatliquors and oils_Natural fatliquors", "2.8.b Fatliquors and oils_Synthetic fatliquors", "2.8.c Polymeric Softeners", "2.8.d Siloxanes / Silicones (Waterproofing)"]
        },
        {
            header: "2.9 FINISHING AGENTS",
            options: ["2.9.b Protein Binders", "2.9.c Crosslinkers (finishing)", "2.9.d Flame retardant agents", "2.9.e Halide Compounds", "2.9.f Handle modifiers", "2.9.g Acrylic polymers (base coat", "2.9.h Cellulose Derivatives (base coat", "2.9.i Polyurethane dispersions (base coat", "2.9.l Matting agents_Inorganic", "2.9.m Matting agents_Organic", "2.9.n Resins", "2.9.o Waxes", "2.9.p Stucco", "2.9.p Patent leather", "2.9.q Transfer coating", "2.9.r Finishing Fillers_Inorganic fillers", "2.9.s Finishing Fillers_Organic fillers", "2.9.t Compounds"]
        },
        {
            header: "2.10 PRESERVING AGENTS",
            options: ["2.10.a Bactericides for preservation during leather manufacture", "2.10.b Fungicides for preservation during leather manufacture", "2.10.c Biocides for transport/article protection", "2.10.d Sanitizers"]
        },
        {
            header: "2.11 SALTS",
            options: []
        },
        {
            header: "2.12 SOLVENTS",
            options: ["2.12.a Solvents_Degreasing solvent", "2.12.b Solvents_Finishing solvent"]
        },
        {
            header: "2.13 TANNING AND RETANNING AGENTS",
            options: ["2.13.a Tanning Auxiliaries", "2.13.b Mineral tanning agents", "2.13.c Mineral / synthetic tanning agent blends", "2.13.d Synthetic organic tanning agents", "2.13.e Vegetable tannins", "2.13.f Reactive organic tanning agents", "2.13.g Resin tanning agents", "2.13.h Polymeric retanning agent", "2.13.i Retanning Fillers_Inorganic fillers", "2.13.l Retanning Fillers_Organic fillers"]
        }
    ]

}
